<template>
  <div class="information-block">
    <div class="block card">
      <div class="card-body">
        <title-block :imagePath="imageTitle.planner"
                     imageAlt=""
                     :title="$t('DashboardPageManager.InformationBlock.current_week.title')"></title-block>
        <div class="block_content p-0">
          <highcharts :options="statsOffersCurrentWeek"></highcharts>
        </div>
        <div class="block_content text-center">
          <router-link :to="{ name: 'Stats', params: { entity_id: entityId } }" class="btn btn-secondary btn-secondary-dark btn-sm">
            {{ $t('DashboardPageManager.InformationBlock.current_week.buttons.view_stats') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="block card user-kit-block">
      <title-block :imagePath="imageTitle.openedFolder"
                   imageAlt=""
                   :title="$t('DashboardPageManager.InformationBlock.user_kit.title')"></title-block>

      <div class="block_content text-center">
        <div class="row">
          <div class="col-6 tutorials" @click="moveToUserKit('tutorial')">
            <user-kit-item :imagePath="imgUserKit.videoPlaylist"
                           image-alt=''
                           :title="$t('DashboardPageManager.InformationBlock.user_kit.tutorials')"
                           class="pointer">
            </user-kit-item>
          </div>
          <div class="col-6 communication" @click="moveToUserKit('communication')">
            <user-kit-item :imagePath="imgUserKit.paste"
                           image-alt=''
                           :title="$t('DashboardPageManager.InformationBlock.user_kit.communication')"
                           class="pointer">
            </user-kit-item>
          </div>
        </div>
        <div class="row">
          <div class="col-6 training" @click="redirectArticleRH">
            <user-kit-item :imagePath="imgUserKit.article"
                           image-alt=''
                           :title="$t('DashboardPageManager.InformationBlock.user_kit.article')"
                           class="pointer">
            </user-kit-item>
          </div>
          <div class="col-6 faq" @click="redirectPageFaq">
            <user-kit-item :imagePath="imgUserKit.questionMark"
                           image-alt=''
                           :title="$t('DashboardPageManager.InformationBlock.user_kit.faq')"
                           class="pointer">
            </user-kit-item>
          </div>
        </div>
      </div>
    </div>
    <div class="block card my-profiles">
      <title-block :imagePath="imageTitle.maleUser"
                   imageAlt=""
                   :title="$t('DashboardPageManager.InformationBlock.my_profile.title')"></title-block>

      <div class="block_content">
        <div>
          <span>{{ $t('DashboardPageManager.InformationBlock.my_profile.mail')}}</span> :
          <span>{{ currentUser.email }}</span>
        </div>

        <div>
          <span>{{ $t('DashboardPageManager.InformationBlock.my_profile.telephone')}}</span> :
          <span>{{ currentUser.phone_display }}</span>
        </div>

        <div class="mt-2 text-center">
          <router-link :to="{ name: 'EditProfile'}" class="btn btn-secondary btn-secondary-dark btn-sm">
            {{ $t('buttons.see_more') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TitleBlock from "./TitleBlock";
  import UserKitItem from "./UserKitItem";
  import imgPlanner from '@/assets/img/pages/icons/planner.png'
  import imgOpenedFolder from '@/assets/img/pages/icons/opened-folder.png'
  import imgMaleUser from '@/assets/img/pages/icons/male-user.png'
  import imgVideoPlaylist from '@/assets/img/pages/icons/video-playlist.png'
  import imgPaste from '@/assets/img/pages/icons/paste.png'
  import imgArticle from '@/assets/img/pages/icons/article.png'
  import imgQuestionMark from '@/assets/img/pages/icons/question-mark.png'
  import { externalLinks } from '@/settings/externalLinks'

  export default {
    name: "InformationBlock",
    props: ['currentUser', 'entityId'],
    data() {
      return {
        imageTitle: {
          planner: imgPlanner,
          openedFolder: imgOpenedFolder,
          maleUser: imgMaleUser
        },
        imgUserKit: {
          videoPlaylist: imgVideoPlaylist,
          paste: imgPaste,
          article: imgArticle,
          questionMark: imgQuestionMark
        }
      }
    },
    components: {
      TitleBlock,
      UserKitItem
    },
    computed: {
      ...mapGetters({
        statsOffersCurrentWeek: 'dashboard/statsOffersCurrentWeek'
      }),
      externalLinks() {
        return externalLinks
      }
    },
    watch: {
      entityId: {
        handler() {
          this.$store.dispatch("dashboard/getStatsOffersCurrentWeek", this.entityId);
        }
      }
    },
    methods: {
      moveToUserKit(tabName) {
        this.$router.push({ name: 'UserKit' })
        this.$store.dispatch("userKit/setActiveTab", tabName)
      },
      redirectPageFaq() {
        window.open(externalLinks.faq, "_blank");
      },
      redirectArticleRH() {
        window.open(externalLinks.rh, "_blank");
      }
    },
    mounted: async function () {
      this.$store.dispatch("dashboard/getStatsOffersCurrentWeek");
    }
  }
</script>

<style>
  .pointer {
    cursor: pointer;
  }

  .btn-p-30px {
    padding-left: 30px;
    padding-right: 30px;
  }

  .user-kit-block {
    padding-left: 10px;
    padding-right: 10px;
  }

  .user-kit-block .tutorials {
    border-right: solid 1px lightgrey;
    border-bottom: solid 1px lightgrey;
  }

  .user-kit-block .communication {
    border-bottom: solid 1px lightgrey;
  }

  .user-kit-block .training{
    border-right: solid 1px lightgrey;
  }

  .my-profiles > .block_content {
    line-height: 1.5rem !important;
  }

  .highcharts-title, .highcharts-container text.highcharts-title {
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manager/InformationBlock.vue